import {
  B1,
  getTranslatedText,
  Loader,
  HeaderTag,
  toast,
  AccessControl
} from '@nile/components';
import {
  AccountClient,
  LIST_CARDS,
  LIST_ACH_ACCOUNTS,
  PAY_INVOICE,
  SETUP_INTEGRATED_PAYMENT
} from '@nile/graphql';
import { useQuery, useMutation } from '@apollo/client';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import React, { useContext, useState, useCallback } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import AddCardModal from '@nile/client_management/src/Pages/Protected/ClientNavigation/AddCardModal';
import { Button, Page, RadioButton } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';

function InvoicePayment(props) {
  const { intl, match, handlePayment, data, client } = props;
  const [allCards, setAllCards] = useState([]);
  const [allAccounts, setAllAccounts] = useState([]);
  const tabContext = useContext(TabContext);

  const [payInvoice] = useMutation(PAY_INVOICE, { client: AccountClient });
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedMethodType, setSelectedMethodType] = useState(null);
  const [modalActive, setModalActive] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [setupIntentId, setSetupIntentId] = useState(null);
  const handleModalChange = useCallback(() => setModalActive(!modalActive), [
    modalActive
  ]);

  const {
    loading: listCardsLoading,
    error: listCardsError,
    refetch
  } = useQuery(LIST_CARDS, {
    client: AccountClient,
    variables: {
      clientId: client.accountId
    },
    fetchPolicy: 'network-only',
    onCompleted({ listCards }) {
      setAllCards(listCards?.cards || []);
    }
  });

  const { loading: listAccountsLoading, error: listAccountsError } = useQuery(
    LIST_ACH_ACCOUNTS,
    {
      client: AccountClient,
      variables: {
        clientId: client.accountId
      },
      fetchPolicy: 'network-only',
      onCompleted({ listACHAccounts }) {
        setAllAccounts(listACHAccounts);
      }
    }
  );

  const [setupIntegratedPayment] = useMutation(SETUP_INTEGRATED_PAYMENT, {
    client: AccountClient
  });

  const [submitActionLoading, setSubmitActionLoading] = useState(false);
  const [addCardSubmitActionLoading, setAddCardSubmitActionLoading] = useState(
    false
  );

  const handleAdd = async () => {
    setAddCardSubmitActionLoading(true);

    try {
      const res = await setupIntegratedPayment({
        variables: {
          input: {
            integration: {
              integrationId: 'STRIPE'
            },
            client: {
              accountId: client?.accountId
            },
            type: 'CARD'
          }
        }
      });

      if (res?.data?.setupIntegratedPaymentMethod) {
        handleModalChange();
        setClientSecret(res.data.setupIntegratedPaymentMethod.client_secret);
        setSetupIntentId(res.data.setupIntegratedPaymentMethod.id);
      }
    } finally {
      setAddCardSubmitActionLoading(false);
    }
  };

  const getCards = () => {
    refetch().then((res) => {
      setAllCards(res?.data?.listCards?.cards || []);
    });
  };

  // if (listCardsLoading || listAccountsLoading)
  //   return (
  //     <LoaderWrapper>
  //       <Loader />
  //     </LoaderWrapper>
  //   );

  return (
    <Page
      variant="primary"
      contentHeight="70px"
      title={
        <div className="flex center">
          <Button
            onClick={handlePayment.bind(this, 'list')}
            icon={<SVGIcon name="BackArrow" size="sm" />}
          />
          <div className="ml-10 f-20">
            <FormattedMessage id="invoice.payment.savedCardDetails" />
          </div>
        </div>
      }
      primaryAction={
        <Button
          onClick={() => {
            setSubmitActionLoading(true);
            payInvoice({
              variables: {
                invoicePayment: {
                  invoiceId: data.invoiceId,
                  paymentMethod: selectedMethodType,
                  paymentMethodId: selectedPaymentMethod
                }
              }
            })
              .then((res) => {
                // tabContext.closeTab();
                handlePayment('list');
                if (res.data.payInvoice) {
                  toast('success', 'invoice.payment.success');
                }
                setSubmitActionLoading(false);
              })
              .catch((err) => {
                setSubmitActionLoading(false);
              });
          }}
          primary
          loading={submitActionLoading}
          icon={<SVGIcon name="Billable" color="#fff" />}
          // loading={submitActionLoading}
        >
          <FormattedMessage id="invoice.payment.action.useThisPaymentMethod" />
        </Button>
      }
    >
      {listCardsLoading || listAccountsLoading ? (
        <div className="d-inline-grid center jctr full-width pt-200">
          <Loader />
        </div>
      ) : (
        <div className="content-padding">
          <div className="mb-20">
            <div className="mb-20">
              <HeaderTag
                title={getTranslatedText(
                  intl,
                  'admin.integrations.stripe.payments.ach.title'
                )}
                isBgStrip
                isNewLayout
              />
            </div>
            {!allAccounts.length && (
              <div className="pr-100">
                <FormattedMessage id="client.invoice.payments.ach.nodata" />
              </div>
            )}
            {allAccounts.map((account, ind) => (
              <div className="flex mb-20">
                <RadioButton
                  // label={''}
                  label={
                    <div className="flex mb-10">
                      <SVGIcon name="BillingAndInvoice" />
                      <B1 className="ml-10">
                        {`${account.bankName} (xxxx xxxx xxxx ${account.last4})`}
                      </B1>
                    </div>
                  }
                  // checked={context.value.payment?.paymentMethodId === account?.id}
                  id={`ach-payment-${ind}`}
                  name="payment-setting"
                  onChange={() => {
                    setSelectedMethodType('ACH');
                    setSelectedPaymentMethod(account.id);
                  }}
                />
              </div>
            ))}
          </div>
          <div className="mb-20">
            <div className="mb-10 flex center">
              <HeaderTag
                title={getTranslatedText(
                  intl,
                  'admin.integrations.stripe.payments.card.title'
                )}
                isBgStrip
                isNewLayout
              />

              <AccessControl
                roleToCheck="paymentSettings.edit"
                render={
                  <div className="mlauto">
                    <Button
                      icon={<SVGIcon name="Add" />}
                      onClick={handleAdd}
                      loading={addCardSubmitActionLoading}
                    >
                      <FormattedMessage id="admin.integrations.stripe.payments.card.add" />
                    </Button>
                  </div>
                }
              />
            </div>
            {listCardsLoading ? (
              <div className="d-inline-grid center jctr full-width pt-200">
                <Loader />
              </div>
            ) : (
              allCards.map((card, ind) => (
                <div className="flex mb-20">
                  <RadioButton
                    id={`card-payment-${ind}`}
                    name="payment-setting"
                    onChange={() => {
                      setSelectedMethodType('CARD');
                      setSelectedPaymentMethod(card.id);
                    }}
                    label={
                      <div className="flex mb-20">
                        <SVGIcon name="BillingAndInvoice" />
                        <B1 className="ml-10">
                          {`${card.brand} (xxxx xxxx xxxx ${card.last4Digits})`}
                        </B1>
                      </div>
                    }
                  />
                  {/* <div className="ml-10 mr-20 w40"></div> */}
                </div>
              ))
            )}
            {!allCards.length && (
              <div className="pr-100">
                <FormattedMessage id="client.invoice.payments.card.nodata" />
              </div>
            )}
            {clientSecret && modalActive && (
              <AddCardModal
                clientSecret={clientSecret}
                setupIntentId={setupIntentId}
                modalActive={modalActive}
                setModalActive={setModalActive}
                getCards={getCards}
                client={client}
              />
            )}
          </div>
        </div>
      )}
    </Page>
  );
}

export default injectIntl(withRouter(InvoicePayment));
